<template>
	<div class="scrollable">
		<v-header></v-header>
		<div class="content">
			<div class="breadNav">
		        <div class="nav">
		        	<p>{{$t('m.accountSecurity.brankNav')}}</p>
		        </div>
		    </div>
		    <div></div>
		</div>
		<v-footer></v-footer>
		<el-dialog
			:title="$t('m.person.changePass')" 
			:visible.sync="passwordVisible"
			:close-on-click-modal="closeOnClickModal"
			>
			<div class="editMsg passwordDialog">
				<div class="name item">
					<p><img src="../../assets/icon/密码.svg"></p>
					<input type="password" name="" :placeholder="$t('m.person.oldPassword')" ref="oldPasswords">
				</div>
				<div class="sex item">
					<p><img src="../../assets/icon/密码.svg"></p>
					<input type="password" name="" :placeholder="$t('m.person.newPassword')" ref="newPassword">
				</div>
				<div class="gender item">
					<p><img src="../../assets/icon/密码.svg"></p>
					<input type="password" name="" :placeholder="$t('m.person.newPasswordAgin')" ref="againPassword">
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="passwordVisible = false">{{$t('m.common.cancelBtn')}}</el-button>
				<el-button type="primary" @click="reviseOkBtn">{{$t('m.common.define')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'; 
import {mapActions, mapGetters} from 'vuex';
import header from '../common/header.vue'  
import footer from '../common/footer.vue'  
export default {
	name: 'accountSecurity',
	data () {
		return {
			passwordVisible:false
	    }
	},
	components: {
		"v-header": header,
		"v-footer":footer
	},
	created() {
		let _this = this;
		
  	},
  	methods:{
  		...mapActions( // 语法糖
		    ['message'] // 相当于this.$store.dispatch('modifyName'),提交这个方法
		    ),
  		// 点击修改密码弹窗里面的确定
		reviseOkBtn(){
			let _this = this;
			
			if(_this.$refs.oldPasswords.value == ''){
				let data={
					message:_this.$t('m.person.oldPasswords'),
					type:'error',
					center:true
				}
				_this.message(data);
			}else if(_this.$refs.newPassword.value == ''){
				let data={
					message:_this.$t('m.person.newPassword'),
					type:'error',
					center:true
				}
				_this.message(data);
			}else if(_this.$refs.againPassword.value == ''){
				let data={
					message:_this.$t('m.person.newPasswordAgin'),
					type:'error',
					center:true
				}
				_this.message(data);
			}else if(_this.$refs.againPassword.value != _this.$refs.newPassword.value){
				let data={
					message:_this.$t('m.person.passwordAtypism'),
					type:'error',
					center:true
				}
				_this.message(data);
			}else{
				axios.put(BASE_URL+'/user/password/',{ 
					old_password: _this.$refs.oldPasswords.value,
					new_password:_this.$refs.newPassword.value
				}).then((res)=>{
					// console.log(res);
					_this.passwordVisible = false;
					let data={
						message:_this.$t('m.person.changePassSuccess'),
						type:'info',
						center:true
					}
					_this.message(data);
				})
			}
		},
	},
	computed: {
	  // ...mapGetters(['quotaDetailsList']) // 动态计算属性，相当于this.$store.getters.resturantName
	},
	mounted(){
		
	}
}
</script>

<style scoped>

.breadNav{
	width: 100%;
	height: 80px;
	border-bottom: 2px solid #EAEAEA;
	display: flex;
	align-items: center;
}
.breadNav .nav{
	width: 1180px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
}
.breadNav .nav p:nth-child(1){
	font-size:18px;
	
	font-weight:600;
	color:#333;
	line-height:20px;
}
.breadNav .nav p:nth-child(2){
	font-size:24px;
	
	font-weight:600;
	color:#e94709;
	line-height:24px;
}

</style>



// WEBPACK FOOTER //
// src/components/personal/accountSecurity.vue